import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type NoteColumnKey =
  | 'user'
  | 'content'
  | 'has_attachment'
  | 'created'
  | 'modified'
  | 'actions'
  | 'door_country'
  | 'door_city'
  | 'door_state'
  | 'door_address'
  | 'door_tags'

export const NOTES_COLUMNS: Record<NoteColumnKey, DataTypeColumn> = {
  user: {
    header: 'User',
    group: 'Note Details',
  },
  content: {
    header: 'Note',
    group: 'Note Details',
  },
  has_attachment: {
    header: 'Attachments',
    group: 'Note Details',
  },
  created: {
    header: 'Date Added',
    group: 'Dates',
  },
  modified: {
    header: 'Date Modified',
    group: 'Dates',
  },
  actions: {
    header: 'Actions',
    group: 'Actions',
  },
  door_country: {
    header: 'Country',
    group: 'Door Details',
  },
  door_city: {
    header: 'City',
    group: 'Door Details',
  },
  door_state: {
    header: 'State',
    group: 'Door Details',
  },
  door_address: {
    header: 'Address',
    group: 'Door Details',
  },
  door_tags: {
    header: 'Door Tags',
    group: 'Door Details',
  },
} satisfies Record<NoteColumnKey, DataTypeColumn>
